export default "__VITE_ASSET__c17e6fcf__"